// extracted by mini-css-extract-plugin
module.exports = {"footerMobile":"AppFooter_footerMobile__iYLhs","footerTabletDesktop":"AppFooter_footerTabletDesktop__IavmG"};